import React, { Component, useEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function RouteReady({ path, onReady, children }: {
  path: string;
  onReady: (path: string) => void;
  children: ReactNode;
}) {
  useEffect(() => { onReady(path); }, [onReady, path]);
  return <>{children}</>;
}

export function LoadFailure() {
  const { t } = useTranslation();
  return (
    <div role="alert" className="fixed inset-0 z-[9999] bg-[#0a0a0a] flex flex-col items-center justify-center px-6 text-center">
      <img src="/images/loading-img.png" alt="AR.Concept" className="w-56 sm:w-72 md:w-80 h-auto" />
      <p className="mt-6 font-inter text-sm text-[#F0EDE8]/60">{t('loadError.message')}</p>
      <button type="button" onClick={() => window.location.reload()} className="mt-6 font-inter text-xs tracking-[0.2em] uppercase text-[#F0EDE8] border-b border-[#F0EDE8]/20 pb-0.5 hover:border-gold hover:text-gold transition-colors duration-300">
        {t('loadError.retry')}
      </button>
    </div>
  );
}

export class RouteErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? <LoadFailure /> : this.props.children; }
}
